var _style, _circle, _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    .q-outline {\r\n      stroke: #008C95;\r\n      fill: none;\r\n      stroke-width: 60;\r\n      stroke-dasharray: 1256;\r\n      stroke-dashoffset: 1256;\r\n      animation: draw 2s ease forwards infinite;\r\n    }\r\n\r\n    .q-tail {\r\n      stroke: #008C95;\r\n      stroke-width: 60;\r\n      stroke-linecap: round;\r\n      stroke-dasharray: 120;\r\n      stroke-dashoffset: 120;\r\n      animation: drawTail 1s ease 1.5s forwards infinite;\r\n    }\r\n\r\n    .q-square {\r\n      fill: #008C95;\r\n      opacity: 0;\r\n      transform-origin: center;\r\n      animation: popIn 0.4s ease forwards infinite;\r\n    }\r\n\r\n    .sq1 { animation-delay: 2s; }\r\n    .sq2 { animation-delay: 2.2s; }\r\n    .sq3 { animation-delay: 2.4s; }\r\n    .sq4 { animation-delay: 2.6s; }\r\n\r\n    @keyframes draw {\r\n      0%   { stroke-dashoffset: 1256; }\r\n      50%  { stroke-dashoffset: 0; }\r\n      100% { stroke-dashoffset: 1256; }\r\n    }\r\n\r\n    @keyframes drawTail {\r\n      0%   { stroke-dashoffset: 120; }\r\n      50%  { stroke-dashoffset: 0; }\r\n      100% { stroke-dashoffset: 120; }\r\n    }\r\n\r\n    @keyframes popIn {\r\n      0%, 100% { opacity: 0; transform: scale(0.5); }\r\n      50% { opacity: 1; transform: scale(1); }\r\n    }\r\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "q-outline",
    cx: 256,
    cy: 256,
    r: 200
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "q-tail",
    d: "M370 370 L450 450"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "q-square sq1",
    x: 190,
    y: 190,
    width: 40,
    height: 40,
    rx: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "q-square sq2",
    x: 282,
    y: 190,
    width: 40,
    height: 40,
    rx: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "q-square sq3",
    x: 190,
    y: 282,
    width: 40,
    height: 40,
    rx: 6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "q-square sq4",
    x: 282,
    y: 282,
    width: 40,
    height: 40,
    rx: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.210d8d2e8bda16a309660b4a3594b936.svg";
export { ForwardRef as ReactComponent };